import {FC, useEffect, useMemo, useState} from "react";
import {usePlanner} from "./PlannerContext";
import moment from "moment";
import {useApi, useFetchedResource} from "../api/APIContext";
import {Button, IconButton} from "@traas/lib/src/components/form/Button";
import {faPlus, faSave, faTimes} from "@fortawesome/free-solid-svg-icons";
import {AddOrderModal} from "../modals/AddOrderModal";
import {useModal} from "@traas/lib/src/components/layout/ModalProvider";
import {DeleteOrderModal} from "../modals/DeleteOrderModal";
import React from "react";
import {OrderAutocomplete} from "@traas/lib/src/components/form/Autocomplete";
import {useApiService} from "../../../lib/src/api/hooks/useApiService";
import config from "../config";
import {getToken} from "@ventumsoftware/react-toolkit";
import {useNavigate} from "react-router";
import { Project } from "@traas/lib/src/api/dto/Project";
import {Order} from "../../../lib/src/api/dto/Order";

export const OrderOverview: FC<{}> = () => {
  // TODO: Move entire (crm)projects call to api when old (proteus)projects stop being used
  const navigate = useNavigate()
  const {projectService} = useApiService(config, getToken, navigate)
  const {resource: projects, loading: loadProjects, reload: reloadProjects} = useFetchedResource<Project[]>(() => projectService.browse());
  useEffect(() => {
    reloadProjects(undefined)
  }, []);

  const {day} = usePlanner()
  const {orders} = useApi()
  const monday = moment(day).set('day', 1)
  const days = [
    monday,
    monday.clone().add(1, 'day'),
    monday.clone().add(2, 'day'),
    monday.clone().add(3, 'day'),
    monday.clone().add(4, 'day'),
    monday.clone().add(5, 'day'),
    monday.clone().add(6, 'day'),
  ]

  const projectsMap = useMemo(() => {
    return projects?.reduce((acc, p) => {
        acc[p.id] = p
        return acc
    }, {} as {[key: string]: Project})
  }, [projects])


  return <div className={"max-w-(--breakpoint-2xl) mx-auto"}>
    {days.map((d, i) => {
      const dayOrders = orders.filter(o => moment(o.deliveryDate).isSame(d, 'day'))
      return <div key={i} className={"flex-1"}>
        <h1 className={"font-medium text-lg"}>{d.toDate().toLocaleDateString('nl', {weekday: 'long', day: 'numeric', month: 'long'})}</h1>
        <div className={'mt-2 mb-8'}>
          {projectsMap && <OrdersCard orders={dayOrders} projectsMap={projectsMap} date={d.toDate()} />}
        </div>
      </div>
    })}
  </div>
}

const OrdersCard: FC<{orders: Order[], projectsMap: {[key: string]: Project}, date: Date}> = (props) => {
  const {createOrder} = useApi()
  // const addOrderModal = useModal({title: 'Bestelling toevoegen', body: <AddOrderModal date={props.date} />})
  const projects = new Set(props.orders.map(o => props.projectsMap[o.projectId]))
  const orders = props.orders.sort((a,b) => {
    return a.createdAt.getTime() > b.createdAt.getTime() ? 1 : -1
  })
  return <div className={"bg-white px-3 py-2 border border-slate-200 rounded-sm"}>
    {orders.length === 0 ? <>
      <div className={"flex flex-col items-center my-4"}>
        <p className={"text-sm text-slate-800 mb-2"}>Nog geen bestellingen.</p>
      </div>
    </> : <>
      <table className={"w-full"}>
        <thead>
          <tr>
            <th className={"text-start pr-6 pb-2 text-sm font-medium text-blue-800 border-b border-slate-100"}>Projectnummer</th>
            <th className={"text-start pr-6 pb-2 text-sm font-medium text-blue-800 border-b border-slate-100"}>Projectnaam</th>
            <th className={"text-start pr-6 pb-2 text-sm font-medium text-blue-800 border-b border-slate-100"}>Artikel</th>
            <th className={"text-start pr-6 pb-2 text-sm font-medium text-blue-800 border-b border-slate-100"}>Hoeveelheid</th>
            <th className={"text-start pr-6 pb-2 text-sm font-medium text-blue-800 border-b border-slate-100"}>Verpakkingseenheid</th>
            <th className={"text-start pr-6 pb-2 text-sm font-medium text-blue-800 border-b border-slate-100"}>Opmerking</th>
          </tr>
        </thead>
        <tbody>
          {Array.from(projects).filter(p => !!p).map((project, i) => {
            const projectOrders = orders.filter(o => o.projectId === project.id)
            const addOrderToProject = async () => {
              await createOrder(Number(project.id), props.date, '_').catch(e => console.error(e))
            }
            return <React.Fragment key={i}>
              {projectOrders.map((order, j, orders) => {
                return <OrdersCardRow key={i * 1000 + j} order={order} orders={orders} project={project} />
              })}
              <tr>
                <td colSpan={2}></td>
                {/*<td colSpan={4}>*/}
                {/*  <Button type={'secondary'} icon={faPlus} size={'sm'} text={'Nieuwe regel'} onClick={addOrderToProject} />*/}
                {/*</td>*/}
              </tr>
            </React.Fragment>
          })}
        </tbody>
      </table>
    </>}

    {/*// TODO: temporarily commented until it's decided to implement adding orders through the planning interface*/}
    {/*// in this case quotes, ledgers, vat rates are needed from the CRM interface*/}
    {/*<div>*/}
    {/*  <Button type={'secondary'} icon={faPlus} size={'sm'} text={'Bestelling toevoegen'} onClick={() => addOrderModal.open()} />*/}
    {/*</div>*/}
  </div>
}
const OrdersCardRow: FC<{order: Order, orders: Order[], project?: Project}> = (props) => {
  // State
  const [isDirty, setIsDirty] = useState(false)
  const {updateOrder} = useApi()

  // TODO: refactor and add when projects work through internal db and not proteus
  async function save() {
    // await updateOrder(props.order.id, undefined, undefined, text.length > 0 ? text : undefined, amount, quantity, quantityUnit.length > 0 ? quantityUnit : undefined, remark.length > 0 ? remark : undefined, isDone)
    //   .catch(e => console.error(e))
    // setIsDirty(false)
  }
  // function dirty<T>(setter: (newValue: T) => void) {
  //   return (newValue: T) => {
  //     setter(newValue)
  //     setIsDirty(true)
  //   }
  // }

  const deleteOrderModal = useModal({title: 'Verwijderen', body: <DeleteOrderModal order={props.order} />})
  const allOrderItems = [...new Set(props.orders.map(order => order.deliveryDate))];

  return <tr className={`text-sm ${props.order.status === 'delivered' ? 'text-slate-500' : 'text-slate-700'}`}>
    <td className={"font-mono xl:w-32 text-sm pr-4"}>{props.project?.projectNumber}</td>
    <td className={"font-medium text-sm pr-4"}>{props.project?.description}</td>
    <td className={``}>{props.order.description ?? '-'}</td>
    <td className={``}>{props.order.amount}</td>
    <td className={``}>{props.order.status}</td>
    <td className={`pl-4`}>
      <div className={"my-1 flex"}>
        {/*<IconButton icon={faSave} disabled={!isDirty} type={'secondary'} size={'sm'} onClick={save} />*/}
        <IconButton icon={faTimes} type={'danger'} size={'sm'} onClick={deleteOrderModal.open} />
      </div>
    </td>
  </tr>
}
const TableTextInput: FC<{value: string, setValue: (newValue: string) => void, className?: string, save: () => void}> = (props) => {
  return <input type={'text'} value={props.value} onChange={e => props.setValue(e.target.value)} className={`w-full px-2 py-1 border border-slate-200 rounded-sm ${props.className??''}`} onBlur={props.save} />
}
const TableNumberInput: FC<{value: number, setValue: (newValue: number) => void, className?: string, save: () => void}> = (props) => {
  return <input type={'number'} value={props.value} onChange={e => props.setValue(Number(e.target.value))} className={`w-full px-2 py-1 border border-slate-200 rounded-sm ${props.className??''}`} onBlur={props.save} />
}